// extracted by mini-css-extract-plugin
export default {"Table":"Table_Table__Nt9uc","cell":"Table_cell__MDT+p","EmptyTable":"Table_EmptyTable__WiKnp"};